import React from 'react';
import { useSessionInfoQuery } from '@/api/useSessionInfoQuery';
import { useSessionStore } from '@/state/sessionStore';

export type UserProfileLinkProps = {
  href?: string;
  className?: string;
  detailsLabel?: string;
};

/**
 * Renders a link to the user profile page when the user is logged in.
 * If the user is a guest, renders nothing.
 * Login state is determined via the session info query (uses sessionStore under the hood).
 */
const UserProfileLink: React.FC<UserProfileLinkProps> = ({
  href = '/user',
  className = 'theme-button block w-full px-3 py-3 text-xl font-bold tracking-wider text-center uppercase',
  detailsLabel = 'My details',
}) => {
  // Trigger session info fetch to keep the store updated
  useSessionInfoQuery();
  const isGuest = useSessionStore((s) => s.isGuest);
  const effectiveIsGuest = isGuest ?? true;

  if (effectiveIsGuest) return null;

  return (
    <a href={href} className={className}>
      {detailsLabel}
    </a>
  );
};

export default UserProfileLink;
